import AbstractComponentController from '../../../core/abstracts/controllers/component-controller';

export default class AlNavigationTabsComponentController extends AbstractComponentController {

    constructor($scope, $injector, $element) {
        super($scope, $injector, $element);

        this.navHelper = this.injector.get('NavHelper');
        this.rootScope = this.injector.get('$rootScope');
        this.stateParams = this.injector.get('$stateParams');
        this.currentStatePathParts = [];
        this.showMobileDropdown = false;
        this.currentMobileDropdown = [];
        this.currentMobileClickedElement = null;

        this.initializing = true;
    }

    $onInit() {
        this._registerEventListeners();
        this._updateCurrentState();
        this._prepareCurrentStatePathForMobile();
    }

    handleNavElementClick(navElement, extendedInformation) {
        this.showMobileDropdown = false;
        this.currentMobileClickedElement = null;
        this.currentMobileDropdown = [];

        extendedInformation = extendedInformation || {};

        this.navHelper.handleElementAction(navElement, extendedInformation);
    }

    handleClickedStatePathElement(clickedElement) {
        this.currentMobileDropdown = [];

        if (this.currentMobileClickedElement && clickedElement.key === this.currentMobileClickedElement.key) {
            this.showMobileDropdown = false;
            this.currentMobileClickedElement = null;
            return;
        }

        if (
            (!clickedElement.dropdown || clickedElement.dropdown.length === 0)
            && (
                clickedElement.type !== 'event-selector'
                || clickedElement.events.length === 0
            )
        ) {
            return;
        }

        this.currentMobileDropdown = _.cloneDeep(clickedElement.dropdown);

        this.currentMobileClickedElement = clickedElement;
        this.showMobileDropdown = true;
    }

    _updateCurrentState() {
        this.currentState = this.navHelper.getCurrentNavigationElement();
        this.initializing = this.navHelper.isInitializing();

        if (this.currentState) {
            let childElements = _.filter(
                this.navHelper.getChildrenByParentKey(this.currentState.key),
                (navElement) => {
                    return navElement.showInNavigation;
                }
            );
            if (this.currentState.showParentTabs || (childElements.length === 0 && this.currentState.parentKey)) {
                childElements = this.navHelper.getChildrenByParentKey(this.currentState.parentKey)
            }
            this.currentChildElements = _.filter(childElements, (element) => {
                if (!element.showInNavigation) {
                    return false;
                }

                if (_.isFunction(element.customAccessor)) {
                    return element.customAccessor(this.injector);
                }

                return true;
            });
        } else {
            this.currentChildElements = [];
        }
    }

    _registerEventListeners() {
        this.rootScope.$on('al-navigation-updated', () => {
            this._updateCurrentState();
            this._prepareCurrentStatePathForMobile();
        })
    }

    _prepareCurrentStatePathForMobile() {
        if (!this.currentState) {
            this.currentStatePathParts = [];
            return;
        }

        const currentStatePath = this.navHelper.getCurrentPathElements(),
            outPaths = [];

        for (let i = 0; i < currentStatePath.length; i++) {
            if(this.currentState.level > 1 && i < 1) {
                continue;
            }

            const curPathElement = _.cloneDeep(currentStatePath[i]);
            curPathElement.mobileNavOptions = [];

            let newDropdown = [];

            if (curPathElement.level === 1) {
                newDropdown = this.navHelper.getRootNavInformation();
            } else if (curPathElement.type !== 'event-selector') {
                newDropdown = this.navHelper.getChildrenByParentKey(curPathElement.parentKey);
            }

            curPathElement.dropdown = _.filter(newDropdown, (navElement) => {
                return navElement.showInNavigation;
            })

            outPaths.push(curPathElement);
        }

        this.currentStatePathParts = outPaths;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/navigation/components/al-navigation-tabs/controller.js